import { motion } from 'framer-motion'
import UpAppLogo from '@/assets/logos/upseat_logo.svg'

export const LoadingScreen = () => (
  <div className="bg-purple gap-4 w-full overflow-hidden h-[100dvh] flex flex-col justify-center items-center text-white">
    <motion.img
      src={UpAppLogo}
      alt="up-logo"
      className={`w-[20vw] desktop:w-[56px]`}
      initial={{ scale: 0.5 }}
      animate={{ rotate: 0, scale: 1 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
    />
  </div>
)
